<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Add New Vehicle Details</strong>
                    </div>

                    <b-row>
                        <b-col sm="6">
                            <b-input-group class="mb-3">
                                <b-form-select
                                  v-model="vehicletype"
                                  name="vehicletype"
                                >
                                  <option :value="selected_type">--Select Vehicle Type--</option>
                                  <option value="regular_vehicle">Regular Vehicle</option>
                                  <option value="adhoc_vehicle">Adhoc Vehicle</option>
                                </b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <div class="p-4" v-if="vehicletype=='regular_vehicle'">
                                <regular_vehicle></regular_vehicle>
                                </div>
                            <div class="p-4" v-if="vehicletype=='adhoc_vehicle'">
                                <adhoc_vehicle></adhoc_vehicle>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import Router from "vue-router";
import adhoc_vehicle from './adhoc_vehicle.vue'
import regular_vehicle from './regular_vehicle.vue'
export default {
    data() {
        return {
            vehicletype: '',
            selected_type :'',
        }
    },
    components: {
        adhoc_vehicle,
        regular_vehicle
    }
}
</script>